import React, { FC } from 'react';

import AdminToolBar from '@rover/react-lib/src/components/AdminToolbar/AdminToolbar';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';

const AdminToolbar: FC = () => {
  const { user } = useCurrentUserShim();
  const { toolbarComponent: CustomAdminToolbar } = usePageContext();

  if (!user?.showAdminToolbar) return null;

  if (CustomAdminToolbar) return <CustomAdminToolbar />;

  return <AdminToolBar />;
};

export default AdminToolbar;
